import Kelimutu1 from '../Kelimutu/Kelimutu (1).webp'
import Kelimutu2 from '../Kelimutu/Kelimutu (2).webp'
import Kelimutu3 from '../Kelimutu/Kelimutu (3).webp'
import Kelimutu4 from '../Kelimutu/Kelimutu (4).webp'
import Kelimutu5 from '../Kelimutu/Kelimutu (5).webp'
import Kelimutu6 from '../Kelimutu/Kelimutu (6).webp'
import Kelimutu7 from '../Kelimutu/Kelimutu (7).webp'
import Kelimutu8 from '../Kelimutu/Kelimutu (8).webp'
import Kelimutu9 from '../Kelimutu/Kelimutu (9).webp'
import Kelimutu10 from '../Kelimutu/Kelimutu (10).webp'
import Kelimutu11 from '../Kelimutu/Kelimutu (11).webp'
import Kelimutu12 from '../Kelimutu/Kelimutu (12).webp'
import Kelimutu13 from '../Kelimutu/Kelimutu (13).webp'
import Kelimutu14 from '../Kelimutu/Kelimutu (14).webp'
import Kelimutu15 from '../Kelimutu/Kelimutu (15).webp'
import Kelimutu16 from '../Kelimutu/Kelimutu (16).webp'
import Kelimutu17 from '../Kelimutu/Kelimutu (17).webp'

const Kelimutuimages =[
Kelimutu1,Kelimutu2,Kelimutu3,Kelimutu4,Kelimutu5,Kelimutu6,Kelimutu7,Kelimutu8,Kelimutu9,Kelimutu10,Kelimutu11,Kelimutu12,Kelimutu13,Kelimutu14,Kelimutu15,Kelimutu16,Kelimutu17
]

export default Kelimutuimages;